import React from "react";
import "./BannerPaginaInterna.css";
import BotaoContato from "../../componentes/BotaoContato/BotaoContato";
import BotaoContatoOutline from "../../componentes/BotaoContatoOutline/BotaoContatoOutline";

function BannerPaginaInterna({
  tag = "Especialidades Técnicas",
  titulo = "Engenharia Aplicada e Projetos Técnicos",
  descricao = "Conheça nossos serviços especializados em engenharia aplicada, desenvolvidos com inovação, sustentabilidade e excelência técnica.",
  textoBotao = "Ver Portfólio",
  rotaBotao = "/",
  mostrarBotaoOutline = false,
  textoBotaoOutline = "Fale Conosco",
  rotaBotaoOutline = "https://wa.me/5532984053160?text=Olá, gostaria de mais informações",
}) {
  return (
    <div className="banner-wrapper">
      <main className="flex-grow">
        <section className="banner-aplicada">
          <div className="banner-bg">
            <div className="banner-overlay"></div>

            <div className="banner-content container">
              <span className="banner-tag">
                {tag}
              </span>

              <h1 className="banner-title">
                {titulo}
              </h1>

              <p className="banner-text">
                {descricao}
              </p>

              <div className="banner-buttons">
                <BotaoContato
                  texto={textoBotao}
                  rota={rotaBotao}
                />

                {/* {mostrarBotaoOutline && (
                  <BotaoContatoOutline
                    texto={textoBotaoOutline}
                    rota={rotaBotaoOutline}
                  />
                )} */}
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default BannerPaginaInterna;